import type { Api } from '@pflegenavi/shared-frontend/platform';
import { get, getApiBaseUrl } from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type {
  ResidentControllerQueryTypes,
  ResidentControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import { ResidentControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';

export interface IResidentApi extends Api {
  getResidentList(dataIn: {
    params: ResidentControllerQueryTypes['getResidentList'];
  }): Promise<ResidentControllerResultTypes['getResidentList']>;
}

export class ResidentApi implements IResidentApi {
  baseUrl: string;

  getResidentList: IResidentApi['getResidentList'];
  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getResidentList = get({
      authContext,

      url: (opts) => {
        const queryParams = new URLSearchParams();
        queryParams.append('nursingHomeId', opts.nursingHomeId.toString());
        queryParams.append(
          'globalServiceProviderId',
          opts.globalServiceProviderId.toString()
        );

        const queryString = queryParams.toString();

        return `${this.baseUrl}/${ResidentControllerDefinition.controller}${ResidentControllerDefinition.endpoints.getResidentList.url}?${queryString}`;
      },
    });
  }
}
